export default function (_defaultTemplate, hit, html, components) {
  const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
  const isWished = (JSON.parse(localStorage.getItem('bls__wishlist-items')) || []).includes(hit.handle);
  const wishlistIconClass = isWished ? 'active' : '';
  const price = hit.min_price || hit.price || 0;
  const compareAtPrice = hit.min_compare_at_price || hit.compare_at_price || 0;
  let discountBadge = '';

  if (compareAtPrice && compareAtPrice > price) {
    const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    discountBadge = `
      <div class="ais-hit-discount-badge fs-12 pointer-events-none absolute">
        <div class="ais-hit-discount-badge__label">-${discount}%</div>
      </div>
    `;
  }

  return `
    <li class="ais-hit-item">
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
        <div class="ais-hit--picture_wrapper relative">
          ${discountBadge}
          <img
              class="ais-hit--picture"
              src="${hitImage.src}"
              srcset="${hitImage.srcset}"
              sizes="${hitImage.sizes}"
              alt="${hit.title} - ${hit.variant_title}"
          />
          <div class="buttons-wrapper">
            <button
              type="button"
              name="add"
              role="button"
              aria-label="Quick View"
              class="bls__quickview-button-js btn-secondary border-none button bls_tooltip button--full-width"
              data-product-handle="${hit.handle}"
            >
              <span class="bls__product-icon">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.0683594 5.90234C0.0227865 5.98438 0 6.07096 0 6.16211C0 6.25326 0.0227865 6.33984 0.0683594 6.42188C0.0683594 6.42188 0.123047 6.52669 0.232422 6.73633C0.341797 6.93685 0.501302 7.19206 0.710938 7.50195C0.847656 7.69336 0.998047 7.90299 1.16211 8.13086C1.33529 8.34961 1.52669 8.57292 1.73633 8.80078C2.00065 9.08333 2.29232 9.36589 2.61133 9.64844C2.93945 9.93099 3.29492 10.1908 3.67773 10.4277C4.14258 10.7194 4.65299 10.9564 5.20898 11.1387C5.76497 11.321 6.36198 11.4121 7 11.4121C7.63802 11.4121 8.23503 11.321 8.79102 11.1387C9.34701 10.9564 9.85742 10.7194 10.3223 10.4277C10.7051 10.1908 11.056 9.93099 11.375 9.64844C11.7031 9.36589 11.9993 9.08333 12.2637 8.80078C12.4733 8.57292 12.6602 8.34961 12.8242 8.13086C12.9974 7.90299 13.1523 7.69336 13.2891 7.50195C13.4987 7.19206 13.6582 6.93685 13.7676 6.73633C13.877 6.52669 13.9316 6.42188 13.9316 6.42188C13.9772 6.34896 14 6.26693 14 6.17578C14 6.08464 13.9772 5.99349 13.9316 5.90234C13.9316 5.90234 13.877 5.80208 13.7676 5.60156C13.6582 5.39193 13.4987 5.13672 13.2891 4.83594C13.1523 4.64453 12.9974 4.43945 12.8242 4.2207C12.6602 3.99284 12.4733 3.76497 12.2637 3.53711C11.9993 3.25456 11.7031 2.97201 11.375 2.68945C11.056 2.4069 10.7051 2.14714 10.3223 1.91016C9.85742 1.61849 9.34701 1.38151 8.79102 1.19922C8.23503 1.00781 7.63802 0.912109 7 0.912109C6.36198 0.912109 5.76497 1.00781 5.20898 1.19922C4.65299 1.38151 4.14258 1.61849 3.67773 1.91016C3.29492 2.14714 2.93945 2.4069 2.61133 2.68945C2.29232 2.97201 2.00065 3.25456 1.73633 3.53711C1.52669 3.76497 1.33529 3.99284 1.16211 4.2207C0.998047 4.43945 0.847656 4.64453 0.710938 4.83594C0.501302 5.13672 0.341797 5.39193 0.232422 5.60156C0.123047 5.80208 0.0683594 5.90234 0.0683594 5.90234ZM1.24414 6.16211C1.29883 6.08008 1.35807 5.98438 1.42188 5.875C1.49479 5.75651 1.58138 5.62891 1.68164 5.49219C1.80013 5.31901 1.93685 5.13216 2.0918 4.93164C2.24674 4.73112 2.41536 4.5306 2.59766 4.33008C2.83464 4.06576 3.0944 3.81055 3.37695 3.56445C3.65951 3.31836 3.96484 3.09505 4.29297 2.89453C4.6849 2.64844 5.10417 2.45247 5.55078 2.30664C6.00651 2.16081 6.48958 2.08789 7 2.08789C7.51042 2.08789 7.98893 2.16081 8.43555 2.30664C8.89128 2.45247 9.3151 2.64844 9.70703 2.89453C10.0352 3.09505 10.3405 3.31836 10.623 3.56445C10.9056 3.81055 11.1654 4.06576 11.4023 4.33008C11.5846 4.5306 11.7533 4.73112 11.9082 4.93164C12.0632 5.13216 12.1999 5.31901 12.3184 5.49219C12.4186 5.62891 12.5007 5.75651 12.5645 5.875C12.6374 5.98438 12.7012 6.08008 12.7559 6.16211C12.7012 6.24414 12.6374 6.3444 12.5645 6.46289C12.5007 6.57227 12.4186 6.69987 12.3184 6.8457C12.1999 7.01888 12.0632 7.20573 11.9082 7.40625C11.7533 7.60677 11.5846 7.80729 11.4023 8.00781C11.1654 8.26302 10.9056 8.51367 10.623 8.75977C10.3405 9.00586 10.0352 9.23372 9.70703 9.44336C9.3151 9.68034 8.89128 9.8763 8.43555 10.0312C7.98893 10.1771 7.51042 10.25 7 10.25C6.48958 10.25 6.00651 10.1771 5.55078 10.0312C5.10417 9.8763 4.6849 9.68034 4.29297 9.44336C3.96484 9.23372 3.65951 9.00586 3.37695 8.75977C3.0944 8.51367 2.83464 8.26302 2.59766 8.00781C2.41536 7.80729 2.24674 7.60677 2.0918 7.40625C1.93685 7.20573 1.80013 7.01888 1.68164 6.8457C1.58138 6.69987 1.49479 6.57227 1.42188 6.46289C1.35807 6.3444 1.29883 6.24414 1.24414 6.16211ZM9.33789 6.16211C9.33789 5.8431 9.27409 5.54232 9.14648 5.25977C9.02799 4.97721 8.86393 4.73112 8.6543 4.52148C8.44466 4.31185 8.19401 4.14779 7.90234 4.0293C7.61979 3.90169 7.31901 3.83789 7 3.83789C6.68099 3.83789 6.37565 3.90169 6.08398 4.0293C5.80143 4.14779 5.55534 4.31185 5.3457 4.52148C5.13607 4.73112 4.96745 4.97721 4.83984 5.25977C4.72135 5.54232 4.66211 5.8431 4.66211 6.16211C4.66211 6.49023 4.72135 6.79557 4.83984 7.07812C4.96745 7.36068 5.13607 7.60677 5.3457 7.81641C5.55534 8.02604 5.80143 8.19466 6.08398 8.32227C6.37565 8.44076 6.68099 8.5 7 8.5C7.31901 8.5 7.61979 8.44076 7.90234 8.32227C8.19401 8.19466 8.44466 8.02604 8.6543 7.81641C8.86393 7.60677 9.02799 7.36068 9.14648 7.07812C9.27409 6.79557 9.33789 6.49023 9.33789 6.16211ZM8.16211 6.16211C8.16211 6.32617 8.13021 6.48112 8.06641 6.62695C8.01172 6.76367 7.92969 6.88672 7.82031 6.99609C7.72005 7.09635 7.59701 7.17839 7.45117 7.24219C7.31445 7.30599 7.16406 7.33789 7 7.33789C6.83594 7.33789 6.68099 7.30599 6.53516 7.24219C6.39844 7.17839 6.27995 7.09635 6.17969 6.99609C6.07031 6.88672 5.98372 6.76367 5.91992 6.62695C5.86523 6.48112 5.83789 6.32617 5.83789 6.16211C5.83789 6.00716 5.86523 5.86133 5.91992 5.72461C5.98372 5.57878 6.07031 5.45117 6.17969 5.3418C6.27995 5.23242 6.39844 5.15039 6.53516 5.0957C6.68099 5.0319 6.83594 5 7 5C7.16406 5 7.31445 5.0319 7.45117 5.0957C7.59701 5.15039 7.72005 5.23242 7.82031 5.3418C7.92969 5.45117 8.01172 5.57878 8.06641 5.72461C8.13021 5.86133 8.16211 6.00716 8.16211 6.16211Z" fill="#111111" />
                </svg>
              </span>
              <span class="bls_tooltip-content">Quickview</span>
            </button>
            <button
              type="button"
              name="add"
              role="button"
              aria-label="button"
              class="btn-reset bls__product-wishlist bls__wishlist-button-js bls__product-wishlist-js bls__product-action-btn-js bls_tooltip ${wishlistIconClass}"
              data-pro-add-wishlist="Add to wishlist"
              data-pro-remove-wishlist="Remove from wishlist"
              data-remove-wishlist="Remove from wishlist"
              data-product-handle="${hit.handle}"
              data-action="redirect"
            >
              <span class="bls__product-icon ${wishlistIconClass}">
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.7441 2.26562C11.9993 2.52083 12.1908 2.8125 12.3184 3.14062C12.446 3.45964 12.5098 3.78776 12.5098 4.125C12.5098 4.46224 12.446 4.79492 12.3184 5.12305C12.1908 5.44206 11.9993 5.72917 11.7441 5.98438L7 10.7285L2.25586 5.98438C2.00065 5.72917 1.80924 5.44206 1.68164 5.12305C1.55404 4.79492 1.49023 4.46224 1.49023 4.125C1.49023 3.78776 1.55404 3.45964 1.68164 3.14062C1.80924 2.8125 2.00065 2.52083 2.25586 2.26562C2.51107 2.01042 2.79818 1.81901 3.11719 1.69141C3.44531 1.5638 3.77799 1.5 4.11523 1.5C4.45247 1.5 4.7806 1.5638 5.09961 1.69141C5.41862 1.81901 5.71029 2.01042 5.97461 2.26562L6.58984 2.88086C6.69922 2.99935 6.83594 3.05859 7 3.05859C7.16406 3.05859 7.30078 2.99935 7.41016 2.88086L8.02539 2.26562C8.28971 2.01042 8.58138 1.81901 8.90039 1.69141C9.2194 1.5638 9.54753 1.5 9.88477 1.5C10.222 1.5 10.5501 1.5638 10.8691 1.69141C11.1973 1.81901 11.4889 2.01042 11.7441 2.26562Z"
                    fill="#111111"/>
                </svg>
              </span>
              <span class="bls_tooltip-content">
                ${isWished ? "Remove from wishlist" : "Add to wishlist"}
              </span>
            </button>
          </div>
        </div>

        <div class="ais-hit--details">
          <p
            class="ais-hit--subtitle bls__product-vendor"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${hit.vendor && instantsearch.highlight({ attribute: 'vendor', hit })}
          </p>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${instantsearch.highlight({ attribute: 'title', hit })}
            </a>
          </p>
          <p class="ais-hit--price bls__product-price">
            <span class="price special-price">${algoliaShopify.helpers.displayPrice(hit, hit.price)}</span>
            ${!hit._distinct &&
              `
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
          </p>
        </div>
      </div>
    </li>
    `;
}
